/**
 * The index of every current policy, at `/legal`.
 *
 * PUBLIC, for the same reason `LegalPage` is: the people most likely to want this
 * list — someone deciding whether to sign up, and anyone checking what we claim
 * before they trust us with a deposit — do not have an account.
 *
 * It renders the WHOLE of `LEGAL_DOCS` with no curation, no "key policies"
 * subset and no ordering of its own. A document that exists but is not listed
 * here is a document nobody can find, and the not-found state on `LegalPage`
 * sends readers straight to this page, so an omission here is what makes a
 * mistyped URL a dead end. `content.test.ts` pins the count at eight.
 */

import { Link } from 'react-router-dom';
import { LegalShell } from './LegalPage';
import { LEGAL_DOCS, LEGAL_VERSION, LEGAL_REVIEW_NOTE, legalPath } from './content';

export function LegalIndexPage() {
  return (
    <LegalShell>
      <span className="inline-block rounded-full px-3 py-1.5 mb-4 text-[11px] font-semibold uppercase tracking-[0.1em] text-brand-teal bg-brand-teal/10 border border-brand-teal/30">
        Policies
      </span>

      <h1 className="font-display font-extrabold text-[34px] sm:text-[40px] leading-[1.05] tracking-[-0.02em] mb-2">
        Our policies
      </h1>
      <p className="text-white/45 text-sm mb-6">
        Everything we have published about how Puntsave works, what it costs, and what we do with
        your money and your data.
      </p>

      <ul className="flex flex-col gap-3 mt-8">
        {LEGAL_DOCS.map((doc) => (
          <li key={doc.slug}>
            <Link
              to={legalPath(doc.slug)}
              className="block rounded-[14px] border border-white/[0.07] bg-white/[0.02] px-5 py-4 hover:border-brand-teal/40 hover:bg-white/[0.04] transition"
            >
              <span className="block font-display font-bold text-[17px] leading-snug mb-1">
                {doc.title}
              </span>
              <span className="block text-white/55 text-[14px] leading-relaxed">{doc.sub}</span>
            </Link>
          </li>
        ))}
      </ul>

      <div className="mt-10 pt-6 border-t border-white/10 flex flex-col gap-2">
        <p className="text-white/35 text-xs">{LEGAL_VERSION}</p>
        <p className="text-white/35 text-xs">{LEGAL_REVIEW_NOTE}</p>
      </div>
    </LegalShell>
  );
}
